/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { SmartImg } from '../../utils';
import { getMeta, fmtDRDate, DR_TYPE_COLORS, DR_PRIORITY } from '../../utils/devRequestUtils';
import { useMarkSeen } from '../../hooks/useDevRequests';
import styles from './devRequests.module.css';

const ICON_BELL    = <svg viewBox="0 0 24 24"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" /></svg>;
const ICON_GLASSES = <svg viewBox="0 0 24 24"><circle cx="6" cy="14" r="4" /><circle cx="18" cy="14" r="4" /><path d="M10 14h4M2 12l2-2M22 12l-2-2" /></svg>;

export function DevRequestNotification({ request, user, onView, onDismiss }) {
  const [progress, setProgress] = useState(100);
  const intervalRef  = useRef(null);
  const markSeen     = useMarkSeen();
  const meta         = getMeta(request);
  const typeClr      = DR_TYPE_COLORS[meta.dev_type || 'DA'] || 'var(--ink-400)';
  const pr           = DR_PRIORITY[meta.priority || 'normal'] || DR_PRIORITY.normal;
  const DURATION_MS  = 30_000;
  const TICK_MS      = 100;

  useEffect(() => {
    const start = Date.now();
    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - start;
      const pct = Math.max(0, 100 - (elapsed / DURATION_MS) * 100);
      setProgress(pct);
      if (pct <= 0) {
        clearInterval(intervalRef.current);
        handleDismiss();
      }
    }, TICK_MS);
    return () => clearInterval(intervalRef.current);
  }, [request?.id]);

  function handleDismiss() {
    clearInterval(intervalRef.current);
    if (user?.email && request?.id) {
      markSeen.mutate({ request, userEmail: user.email });
    }
    onDismiss();
  }

  function handleView() {
    clearInterval(intervalRef.current);
    if (user?.email && request?.id) {
      markSeen.mutate({ request, userEmail: user.email });
    }
    onView(request);
  }

  const notes = meta.notes || '';
  const notesExcerpt = notes.length > 120 ? notes.slice(0, 117) + '...' : notes;

  return (
    <div className={`${styles.dna} ${styles.notifOverlay}`}>
      <div className={styles.notifCard}>
        <div className={styles.notifAccent} />
        <div className={styles.notifMain}>
          <div className={styles.notifHead}>
            <div className={styles.notifEyebrow}>{ICON_BELL} New development request</div>
          </div>

          <div className={styles.notifBody}>
            <div className={styles.notifItem}>
              {meta.images?.[0] ? (
                <SmartImg src={meta.images[0]} displayWidth={64} alt={meta.model} className={styles.notifThumb} />
              ) : (
                <div className={styles.notifPh}>{ICON_GLASSES}</div>
              )}
              <div className={styles.notifInfo}>
                <div className={styles.notifModel}>{meta.model || '—'}</div>
                {meta.brand && <div className={styles.notifBrand}>{meta.brand}</div>}
                <div className={styles.notifChips}>
                  <span className={styles.typeBadge} style={{ color: typeClr, background: typeClr + '14' }}>{meta.dev_type || 'DA'}</span>
                  <span className={styles.prTxt} style={{ color: pr.color }}>{pr.label}</span>
                  {meta.material && <span className={styles.previewMeta}>{meta.material}</span>}
                </div>
                <div className={styles.notifDate}>{fmtDRDate(request.created_at)}</div>
              </div>
            </div>

            {notesExcerpt && <div className={styles.notifNotes}>"{notesExcerpt}"</div>}

            <div className={styles.notifActions}>
              <button onClick={handleView} className={styles.notifView}>View request</button>
              <button onClick={handleDismiss} className={styles.notifDismiss}>Dismiss</button>
            </div>
          </div>

          <div className={styles.notifBarTrack}>
            <div className={styles.notifBar} style={{ width: `${progress}%`, transition: `width ${TICK_MS}ms linear` }} />
          </div>
        </div>
      </div>
    </div>
  );
}
